import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import React, { FC } from 'react';
import DashboardOrderCard from '../../../DashboardOrderCard';
import { useDashboardUIStore } from '@src/pages/DeliveryDashboard/store/dashboardUIStore';
import { useDashboardMapStore } from '@src/pages/DeliveryDashboard/store/dashboardMapStore';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import {
  DeliveryDashboardScreens,
  OrderPaymentStatus,
} from '@src/pages/DeliveryDashboard/models/model-enum';
import { DETAILED_ZOOM_LEVEL } from '@src/pages/DeliveryDashboard/models/model-constants';
import { globalStyles } from 'snacks-design-system';
import { IOrder } from '@src/pages/DeliveryDashboard/models/model-interface';
import useBoundDashboardStore from '@src/pages/DeliveryDashboard/store/dashboardGlobalStore';

interface ICourierDetailOrderCardProps {
  orderData: IOrder;
}

export const CourierDetailOrderCard: FC<ICourierDetailOrderCardProps> = ({ orderData }) => {
  const { setActiveScreen, setActiveOrderHash, setActiveCourierId, activeCourierId } =
    useDashboardUIStore();

  const { setMapPanOffset, setMapZoomLevel, setMapCenter } = useDashboardMapStore();
  const { isResolutionMobile } = useDeviceDetect();
  const { xdsSpacingD } = globalStyles;
  const { getOrderEtaByUUID } = useBoundDashboardStore();

  return (
    <>
      <PIEComponentUtil marginBottom={xdsSpacingD} marginTop={xdsSpacingD}>
        <DashboardOrderCard
          uuid={orderData.uuid}
          onClick={() => {
            setActiveOrderHash(orderData.hash);
            activeCourierId ? setActiveCourierId(null) : null;
            setActiveScreen(DeliveryDashboardScreens.ORDER_DETAIL_SCREEN);
            setMapCenter({
              lat: orderData.location.latitude,
              lng: orderData.location.longitude,
            });
            setMapZoomLevel(DETAILED_ZOOM_LEVEL);
            isResolutionMobile ? setMapPanOffset(70) : null;
          }}
          elevation={true}
          orderStatus={orderData.status}
          customerName={orderData?.customer.lastName || ''}
          courier={orderData?.courier}
          updateDate={orderData?.updateDate}
          isCourierDetailView={activeCourierId ? true : false}
          city={orderData?.customer.address.city || ''}
          postCode={orderData?.customer.address.postcode || ''}
          isPaid={orderData?.payment?.status === OrderPaymentStatus.Paid}
          isContainAlcohol={!!orderData?.hasAlcohol}
          address={`${orderData?.customer.address.street} ${orderData?.customer.address.streetNumber}`}
          dueTime={orderData.expectedDeliveryTime}
          orderETA={orderData?.uuid ? getOrderEtaByUUID(orderData.uuid) : false}
        />
      </PIEComponentUtil>
    </>
  );
};

export default CourierDetailOrderCard;
